/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */
import type {
    QueryClient,
    QueryKey,
    QueryObserverOptions,
    UseQueryResult,
} from '@tanstack/react-query'
import { queryOptions, useQuery } from '@tanstack/react-query'

import fetch from 'Common/utils/query/workRequestClient.ts'
import type {
    RequestConfig,
    ResponseConfig,
    ResponseErrorConfig,
} from 'Common/utils/query/workRequestClient.ts'

import type { GetV1SettingsDiscountnumbersQueryResponse } from '../../types/GetV1SettingsDiscountnumbers.ts'

export const getV1SettingsDiscountnumbersQueryKey = () =>
    [{ url: '/v1/settings/discountnumbers' }] as const

export type GetV1SettingsDiscountnumbersQueryKey = ReturnType<
    typeof getV1SettingsDiscountnumbersQueryKey
>

/**
 * {@link /v1/settings/discountnumbers}
 */
export async function getV1SettingsDiscountnumbers(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const { client: request = fetch, ...requestConfig } = config

    const res = await request<
        GetV1SettingsDiscountnumbersQueryResponse,
        ResponseErrorConfig<Error>,
        unknown
    >({ method: 'GET', url: `/v1/settings/discountnumbers`, ...requestConfig })
    return res
}

export function getV1SettingsDiscountnumbersQueryOptions(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const queryKey = getV1SettingsDiscountnumbersQueryKey()
    return queryOptions<
        ResponseConfig<GetV1SettingsDiscountnumbersQueryResponse>,
        ResponseErrorConfig<Error>,
        ResponseConfig<GetV1SettingsDiscountnumbersQueryResponse>,
        typeof queryKey
    >({
        queryKey,
        queryFn: async ({ signal }) => {
            config.signal = signal
            return getV1SettingsDiscountnumbers(config)
        },
    })
}

/**
 * {@link /v1/settings/discountnumbers}
 */
export function useGetV1SettingsDiscountnumbers<
    TData = ResponseConfig<GetV1SettingsDiscountnumbersQueryResponse>,
    TQueryData = ResponseConfig<GetV1SettingsDiscountnumbersQueryResponse>,
    TQueryKey extends QueryKey = GetV1SettingsDiscountnumbersQueryKey,
>(
    options: {
        query?: Partial<
            QueryObserverOptions<
                ResponseConfig<GetV1SettingsDiscountnumbersQueryResponse>,
                ResponseErrorConfig<Error>,
                TData,
                TQueryData,
                TQueryKey
            >
        > & { client?: QueryClient }
        client?: Partial<RequestConfig> & { client?: typeof fetch }
    } = {},
) {
    const { query: queryConfig = {}, client: config = {} } = options ?? {}
    const { client: queryClient, ...queryOptions } = queryConfig
    const queryKey = queryOptions?.queryKey ?? getV1SettingsDiscountnumbersQueryKey()

    const query = useQuery(
        {
            ...getV1SettingsDiscountnumbersQueryOptions(config),
            queryKey,
            ...queryOptions,
        } as unknown as QueryObserverOptions,
        queryClient,
    ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

    query.queryKey = queryKey as TQueryKey

    return query
}
